import React, {useState} from "react";

import './_recordings.scss'
import {Breadcrumb, BreadcrumbItem, Column, DatePicker, DatePickerInput, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import RecordingTable from "../../../components/RecordingTable";
import {RecordingOperatorDonut, RecordingSystemStats} from "../../../components/RecordingStats";
import moment from "moment";

const Recordings = () => {
  const [date, setDate] = useState(new Date())
  return (
    <Grid fullWidth className="recordings-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Rendicontazioni
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Rendicontazioni
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="recordings-page__r1">
            <Tile>
              <DatePicker
                allowInput={false}
                datePickerType="single"
                dateFormat="m/Y"
                locale="it"
                value={moment(date).format("MM/YYYY")}
                onClose={(raw, date) => {
                  setDate(moment(date, 'MM/YYYY').toDate())
                }}>
                <DatePickerInput
                  placeholder="mm/yyyy"
                  labelText="Mese di riferimento"
                  id="date-picker-single"
                  size="md"/>
              </DatePicker>
            </Tile>
          </Column>
          <Column lg={16} md={8} sm={4}>
            <Grid>
              <Column lg={11} md={8} sm={4} className="recordings-page__r1">
                <Tile>
                  <RecordingSystemStats dateRef={date}/>
                </Tile>
              </Column>
              <Column lg={5} md={8} sm={4} className="recordings-page__r1">
                <Tile>
                  <RecordingOperatorDonut dateRef={date}/>
                </Tile>
              </Column>
            </Grid>
          </Column>
          <Column lg={16} md={8} sm={4} className="recordings-page__r1">
            <Tile>
              <RecordingTable dateRef={date}/>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default Recordings